import { Heading2 } from "@/components/podkit/typography/Headings";
import { type FC } from "react";
import type { PlainWorkflowTrigger } from "@/queries/automation-queries";
import { WorkflowTriggerConfiguration } from "@/components/automations/AutomationTriggerConfiguration";

type WorkflowTriggerSectionProps = {
    triggers?: PlainWorkflowTrigger[];
};

export const WorkflowTriggerSection: FC<WorkflowTriggerSectionProps> = ({ triggers }) => {
    return (
        <div className="flex flex-col gap-2">
            <Heading2 className="text-base font-medium">Triggers</Heading2>
            <div>
                {triggers?.map((trigger) => (
                    <WorkflowTriggerConfiguration key={trigger.trigger.case} trigger={trigger} />
                ))}
            </div>
        </div>
    );
};
